<template>
  <div class="table-card mb-3">
    <table class="responsive-table">
      <thead>
        <tr>
          <th/>
          <th>Document</th>
          <th>License</th>
          <th>Number</th>
          <th>State</th>
          <th>Expires</th>

          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="document in this.documents.documents"
          :key="document.fileUploadId"
        >
        <td >
          <font-awesome-icon
            :icon="['fas', 'circle']"
            :color="presentStatusColor(document)"
            :title="presentStatusText(document)"
            class="icon alt"
          />
          <label class="d-block d-md-none"> Status </label>
        </td>
        <td>
          {{presentDocumentType(document)}}            
          <label class="d-block d-md-none"> Document </label>
        </td>
        <td>
          {{presentLicenseType(document)}}
          <label class="d-block d-md-none"> License </label>
        </td>
        <td>
          {{presentLicenseNumber(document)}}
          <label class="d-block d-md-none"> Number </label>
        </td>
        <td>
          {{presentState(document)}}
          <label class="d-block d-md-none"> State </label>
        </td>
        <td>
          {{presentExpirationDate(document)}}
          <label class="d-block d-md-none"> Expires </label>
        </td>

        <td class="icons">
          <a :href="document.signedGetUrl" target="_blank">
            <font-awesome-icon
              title="View Document"
              :icon="['fas', 'file-alt']"
              class="icon alt"
            />
          </a>
          <!-- <button>
            <font-awesome-icon
              :icon="['fas', 'trash']"
              class="icon alt"
            />
          </button> -->
        </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import UserClient from '@/api/UserClient'
import moment from 'moment'

export default {
  name: 'DocumentTable',
  inject:['documents'],
  data(){
    return {
      userClient: new UserClient(this.$http),
      usStates: [],
    }
  },
  async mounted(){
    const states  = await this.userClient.getStatesList('', 500);
    this.usStates = states.results || []
  },
  methods:{
    presentDocumentType(document){
      switch(document.documentType) {
        case 'license': return "License"
        case 'governmentId': return "Photo Id"
        case 'insurance': return "Insurance"
        case 'originalLicense': return "Original License"
        default: return 'Unknown'
      }
    },
    presentLicenseType(document){
      if(!document.type)
        return '-'
      switch(document.type) {
        case 'CreativeArtsTherapy': return 'Creative Arts Therapy';
        case 'LicensedClinicalProfessionalCounselor': return 'LCPC'// - Licensed Clinical Professional Counselor';
        case 'LicensedClinicalSocialWorker': return 'LCSW'// - Licensed Clinical Social Worker';
        case 'LicensedIndependentClinicalSocialWorker': return 'LICSW'// - Licensed Independent Clinical Social Worker';
        case 'LicensedIndependentSocialWorker': return 'LISW'// - Licensed Independent Social Worker';
        case 'LicensedMarriageAndFamilyTherapist': return 'LMFT'// - Licensed Marriage And Family Therapist';
        case 'LicensedMasterSocialWorker': return 'LMSW'// - Licensed Master Social Worker';
        case 'LicensedMentalHealthCounselor': return 'LMHC'// - Licensed Mental Health Counselor';
        case 'LicensedMentalHealthPractitioner': return 'LMHP'// - Licensed Mental Health Practitioner';
        case 'LicensedProfessionalClinicalCounselorOfMentalHealth': return 'LPCC'// - Licensed Professional Clinical Counselor of Mental Health';
        case 'LicensedProfessionalCounselor': return 'LPC'//  - Licensed Professional Counselor';
        case 'PsychiatricNursePractitioner': return 'Psychiatric Nurse Practitioner';
        case 'Psychiatrists': return 'Psychiatrists';
        case 'Psychologists': return 'Psychologists';
        case 'Unknown': return 'Other';
        default: '-'
      }
    },
    presentLicenseNumber(document) {
      if(!document.licenseNumber)
        return "-"
      return document.licenseNumber;
    },
    presentState(document){
      const state = this.usStates.find(x => x.id === Number(document.usStateId));
      if(!state)
        return '-';
      return state.short_name;
    },
    presentExpirationDate(document){
      if(!document.expires)
        return '-'

      return moment(document.expires).format('M/D/YYYY')
    },
    presentStatusText(document) {
      const good = 'Approved'
      const waiting = 'Requested'
      if(document.documentType === 'governmentId')
        return !!document.fileUploadId ? good : waiting;
      if(document.documentType === 'insurance')
        return !!document.fileUploadId ? good : waiting;
      if(document.documentType === 'originalLicense')
        return !!document.fileUploadId ? good : waiting;

      return document.status;
    },
    presentStatusColor(document){
      const good = 'green'
      const waiting = 'yellow'
      const bad = 'red'
      if(document.documentType === 'governmentId')
        return !!document.fileUploadId ? good : waiting;
      if(document.documentType === 'insurance')
        return !!document.fileUploadId ? good : waiting;
      if(document.documentType === 'originalLicense')
        return !!document.fileUploadId ? good : waiting;

      switch(document.status){
        case 'Approved': return good;
        case 'Rejected':
        case 'Removed': return bad;
        case 'Requested': return waiting;
        default: return 'white';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-card {
  @include border-radius($border-radius);

  border: solid 1px $border-color;
  margin-top: 30px;
  padding: 20px;
}

.responsive-table {
  @include border-radius($border-radius);

  width: 100%;
  border: none;

  thead {
    background: none;
    color: white;

    th {
      position: relative;
      padding: 0.75rem;
      padding-right: $gutter;
      white-space: nowrap;
      border-bottom: 2px solid rgba(255, 255, 255, 0.25);
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;

      i,
      svg {
        position: absolute;
        top: 17px;
        right: 10px;
      }

      .fa-sort {
        z-index: 1;
        opacity: 0.2;
      }

      span {
        .fa-sort-up {
          z-index: 2;
          opacity: 0;
        }

        .fa-sort-down {
          z-index: 3;
          opacity: 0;
        }

        &.active-down {
          .fa-sort-down {
            opacity: 1;
          }
        }

        &.active-up {
          .fa-sort-up {
            opacity: 1;
          }
        }
      }

      &:hover {
        .fa-sort {
          opacity: 0.3;
        }

        span {
          .fa-sort-down {
            opacity: 1;
          }

          &.active-down {
            .fa-sort-down {
              opacity: 1;
            }

            .fa-sort-up {
              opacity: 0;
            }
          }

          &.active-up {
            .fa-sort-up {
              opacity: 1;
            }

            .fa-sort-down {
              opacity: 0;
            }
          }
        }
      }
    }
  }

  tbody {
    tr {
      td {
        padding: 0.75rem;
        color: rgba(white, 0.87);
        border-top: 1px solid rgba(255, 255, 255, 0.25);

        a {
          color: darken($highlight-color, 5%);
        }
      }
    }
  }

  .actions {
    text-align: right;
  }

  @media (max-width: $sm-max) {
    display: block;
    border: none;

    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    tbody {
      tr {
        background: $dark-blue;

        td {
          padding: 0.75rem;
          text-align: right;
          border-bottom: none;
          border-top: 1px solid rgba(255, 255, 255, 0.25);

          &:last-of-type {
            border-bottom: none;
          }
        }
      }
    }

    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr {
      @include border-radius($border-radius);

      margin: 0 0 1rem 0;
      background: white;
    }

    td {
      position: relative;
      padding-left: 50%;
      border: none;
      border-bottom: $secondary-border;

      label {
        position: absolute;
        top: 12.5px;
        left: 15px;
        width: 45%;
        padding-right: 10px;
        font-weight: bold;
        white-space: nowrap;
        text-align: left;
      }
    }

    .btn-ghost {
      border-color: $primary-color;
      background: $primary-color;
      color: $btn-color;
      height: 45px;

      &:hover,
      &:focus {
        border-color: darken($primary-color, 5%);
        background-color: darken($primary-color, 5%);
        color: $btn-color;
      }
    }
  }

  .icons {
    color: $green;
    text-align: right;
    white-space: nowrap;

    button {
      border: none;
      background: none;
      color: $green;
      margin-left: 10px;
    }
  }
}
</style>
